import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-ccs-help-support',
  templateUrl: './ccs-help-support.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsHelpSupportComponent {}
